'use client';

import { ArrowBackwardLtr2pxIcon } from '@dpa/react-icons';
import { RtButton } from '@dpa/react-buttons';
import { backButtonClickEvent } from '@/_analytic/events/back-button-click-event';
import { EPageType } from '@/_analytic/_types';
import {
  sendAnalyticsEvent,
  TSendAnalyticsEventProps,
} from '@/_analytic/send-analytics-event';
import { useRouter } from '@/i18n/navigation';
import { getIsSideMode, getHelpCenterType } from '@/_utils';
import { useClientSearchParams } from '@/_hooks/use-client-search-params';
import { getIframeParentUrl } from '@/_analytic/_utils/get-iframe-parent-url/get-iframe-parent-url';

export type TClientBackButtonProps = {
  text: string;
  pageType: EPageType;
  customEventParams?: TSendAnalyticsEventProps;
  isGoBackMode?: boolean;
};

export const ClientBackButton = ({
  isGoBackMode,
  text,
  pageType,
  customEventParams,
}: TClientBackButtonProps) => {
  const route = useRouter();
  const searchParams = useClientSearchParams();
  const isSideMode = getIsSideMode(searchParams);
  const helpCenterType = getHelpCenterType(isSideMode);

  const handleClick = () => {
    backButtonClickEvent({
      pageName: document.title,
      pageType,
      helpCenterType,
      url: getIframeParentUrl(),
    });
    if (customEventParams) {
      sendAnalyticsEvent(customEventParams);
    }
    if (isGoBackMode) {
      route.back();
    }
  };

  return (
    <RtButton
      label={text}
      modifier="base"
      radius="primary"
      size="lg"
      type="button"
      use="achromatic-cloudy"
      leadingIcon={ArrowBackwardLtr2pxIcon}
      onClick={handleClick}
    />
  );
};
